import type { OrderSummaryProps } from '../../components/ConfirmStep/OrderSummary';
import type { CartEntryItem, CheckoutFlowInfo, Order } from '../../types';
import { safePersistedStore } from '$global/utils/safePersistedStore/safePersistedStore';

export type OrderConfirmation = {
	order: Order & {
		customerInfoText?: string | undefined | null;
		customerSupportText?: string | undefined | null;
		withdrawalFee?: number;
		subscriptionStartDate?: string;
		subscriptionProductPrice?: number;
	};
	acceptPartialAllocation: boolean | undefined;
	variant: 'classic' | 'vault';
	formattedItems: CartEntryItem[] | undefined;
	orderSummaryProps: Partial<OrderSummaryProps>;
	showBillingInsteadOfShipping: boolean;
	// Set for a hybrid checkout only: the confirmation page splits the order
	// the same way the confirm step did.
	checkoutFlow?: CheckoutFlowInfo | undefined;
};

export type OrderConfirmationStore = ReturnType<
	typeof createOrderConfirmationStore
>;

export const createOrderConfirmationStore = (key: string) => {
	const orderConfirmation = safePersistedStore(`${key}-order-confirmation`, {
		all: null,
	} as Record<string, null | OrderConfirmation>);

	const clearOrderConfirmation = (slug?: string) => {
		if (slug) {
			orderConfirmation.update(
				($orderConfirmation: Record<string, null | OrderConfirmation>) => ({
					...$orderConfirmation,
					[slug]: null,
				})
			);

			return;
		}

		orderConfirmation.set({
			all: null,
		});
	};

	const addOrderConfirmation = (slug: string, order: OrderConfirmation) => {
		orderConfirmation.update(
			($orderConfirmation: Record<string, null | OrderConfirmation>) => ({
				...$orderConfirmation,
				[slug]: order,
			})
		);
	};

	return { orderConfirmation, clearOrderConfirmation, addOrderConfirmation };
};
